// Utilities to manage an allow list. An allow list is a list of URLs that are allowed to be
// interacted with. The list itself is a mapping of URL to status. The status can be one of
// the following:
//
// - CONNECTING...
// - SUCCESS
// - FAILED

export const SUCCESS = 'SUCCESS'
const CONNECTING = 'CONNECTING...'
const FAILED = 'FAILED'

async function fetchWithTimeout(resource, options = {}) {
  const { timeout = 2000 } = options

  const controller = new AbortController()
  const id = setTimeout(() => controller.abort(), timeout)

  const response = await fetch(resource, {
    ...options,
    signal: controller.signal,
  })
  clearTimeout(id)

  return response
}

export const isConnecting = (allowList, url) => {
  return allowList[url] === CONNECTING
}

export const isSuccess = (allowList, url) => {
  return allowList[url] === SUCCESS
}

export const isFailed = (allowList, url) => {
  return allowList[url] === FAILED
}

export const defaultAllowList = (uriList) => {
  return uriList.reduce((acc, url) => {
    acc[url] = CONNECTING
    return acc
  }, {})
}

export const resetAllowList = (allowList) => {
  Object.keys(allowList).forEach((url) => {
    allowList[url] = CONNECTING
  })
}

export const updateAllowList = (allowList, successCallback, failureCallback) => {
  Object.keys(allowList).forEach((url) => {
    fetchWithTimeout(url, { mode: 'no-cors' })
      .then(() => {
        allowList[url] = SUCCESS
        successCallback(url)
      })
      .catch(() => {
        allowList[url] = FAILED
        failureCallback(url)
      })
  })
}
